export const CAMPAIGN_SOURCE = "marriott";

/**
 * Builds the /campaign URL for a /multiCampaign request, picking one of the
 * requested `expId` values at random. Returns null when cSource or expId is
 * missing.
 */
export const buildCampaignRedirect = (search, random = Math.random) => {
  const searchParams = new URLSearchParams(search);
  const cSource = searchParams.get("cSource");
  const expIds = searchParams.getAll("expId").filter(Boolean);

  if (!cSource || expIds.length === 0) {
    return null;
  }

  const index = Math.min(Math.floor(random() * expIds.length), expIds.length - 1);
  const destinationParams = new URLSearchParams({
    cSource: CAMPAIGN_SOURCE,
    expId: expIds[index],
  });

  for (const name of ["acid", "channelSrc", "test"]) {
    const value = searchParams.get(name);
    if (value) {
      destinationParams.set(name, value);
    }
  }

  return `/campaign?${destinationParams}`;
};
